import React from 'react';
import { usePagination } from 'react-instantsearch';
import PropTypes from 'prop-types';

const classnames = require('classnames');

export const PagingToolbar = ({ scrollToRef }) => {
    const { currentRefinement, nbPages, refine } = usePagination();

    if (nbPages <= 1) {
        return null;
    }

    const isFirstPage = currentRefinement === 0;
    const isLastPage = currentRefinement === nbPages;

    const firstPageButton = classnames('double', { disabled: isFirstPage });
    const prevPageButton = classnames('single', { disabled: isFirstPage });
    const nextPageButton = classnames('single', { disabled: isLastPage });
    const lastPageButton = classnames('double', { disabled: isLastPage });

    const handleScroll = () => {
        if (!scrollToRef) {
            return;
        }

        const bodyRect = document.body.getBoundingClientRect();
        const scrollRect = scrollToRef.current.getBoundingClientRect();
        const offset = scrollRect.top - bodyRect.top;

        window.scrollTo({
            top: offset,
            behavior: 'smooth',
        });
    };

    return (
        <nav aria-label="Page Navigation">
            <ul className="pagination justify-content-center m-0">
                <li className="page-item">
                    <button
                        type="button"
                        className="page-link h-100"
                        aria-label="First"
                        style={styles.button}
                        onClick={() => {
                            handleScroll();
                            if (!isFirstPage) {
                                refine(0);
                            }
                        }}
                    >
                        <img
                            src="/assets/images/arrow-double-back.svg"
                            alt="Pagination Arrow"
                            aria-hidden="true"
                            className={firstPageButton}
                        />
                    </button>
                </li>

                <li className="page-item">
                    <button
                        type="button"
                        className="page-link h-100"
                        aria-label="Previous"
                        style={styles.button}
                        onClick={() => {
                            handleScroll();
                            if (!isFirstPage) {
                                refine(currentRefinement - 1);
                            }
                        }}
                    >
                        <img
                            src="/assets/images/back-arrow.svg"
                            alt="Pagination Arrow"
                            aria-hidden="true"
                            className={prevPageButton}
                        />
                    </button>
                </li>

                <li className="page-item">
                    <span className="page-link h-100 hits display9 secondary active no-hover d-inline-block">
                        {currentRefinement + 1} of {nbPages}
                    </span>
                </li>

                <li className="page-item">
                    <button
                        type="button"
                        className="page-link h-100"
                        aria-label="Next"
                        style={styles.button}
                        onClick={() => {
                            handleScroll();
                            if (!isLastPage) {
                                refine(currentRefinement + 1);
                            }
                        }}
                    >
                        <img
                            src="/assets/images/forward.svg"
                            alt="Pagination Arrow"
                            aria-hidden="true"
                            className={nextPageButton}
                        />
                    </button>
                </li>

                <li className="page-item">
                    <button
                        type="button"
                        className="page-link h-100"
                        aria-label="Last"
                        style={styles.button}
                        onClick={() => {
                            handleScroll();
                            if (!isLastPage) {
                                refine(nbPages - 1);
                            }
                        }}
                    >
                        <img
                            src="/assets/images/arrow-double-forward.svg"
                            alt="Pagination Arrow"
                            aria-hidden="true"
                            className={lastPageButton}
                        />
                    </button>
                </li>
            </ul>
        </nav>
    );
};

PagingToolbar.propTypes = {
    scrollToRef: PropTypes.object,
};

const styles = {
    button: {
        outline: 'none',
    },
};
